import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

export const seatLimitDetail = error => {
  const data = error?.response?.data;
  const detail = data?.seat_limit_detail || data?.detail;
  return detail?.code === "seat_limit_reached" ? detail : null;
};

export function seatLimitMessage(detail) {
  if (!detail) return "Unable to change membership.";
  const next = detail.next_plan === "fleet" ? "Contact support about Fleet / custom capacity." : `Review the ${detail.next_plan} plan for up to ${detail.next_plan_limit} active users.`;
  return `${detail.current_plan_name || detail.current_plan}: ${detail.current_usage} of ${detail.current_limit} active users. ${next}`;
}

export default function SeatLimitDialog({ detail, onClose, canManage }) {
  return <Dialog open={!!detail} onOpenChange={open => !open && onClose()}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>You’ve reached your {detail?.current_plan_name || detail?.current_plan} plan limit</DialogTitle>
        <DialogDescription>{detail ? seatLimitMessage(detail) : ""}</DialogDescription>
      </DialogHeader>
      {!canManage && <p className="text-sm text-zinc-500">Ask your organisation admin to review the plan.</p>}
      <DialogFooter>
        <Button variant="outline" onClick={onClose}>Cancel</Button>
        {canManage && <Button asChild><Link to={detail?.next_plan === "fleet" ? "/app/billing" : `/app/billing?review=${encodeURIComponent(detail?.next_plan || "")}`} onClick={onClose}>Review upgrade</Link></Button>}
      </DialogFooter>
    </DialogContent>
  </Dialog>;
}
